import { supabase } from '../supabaseClient';
import { getCachedUserAndProfile } from '../utils/userCache';

/**
 * 取得可指派的使用者列表（用於負責人選擇）
 * 遷移後 profiles 有完整的 name, avatar_url, role, company_id, department_id
 * @param {number|null} departmentId - 部門 ID（用於過濾）
 */
export const getAllProfiles = async (departmentId = null) => {
  try {
    const { user } = await getCachedUserAndProfile(supabase);

    if (!user) {
      return { data: [], error: new Error('使用者未登入') };
    }

    let query = supabase
      .from('profiles')
      .select('id, email, name, avatar_url, role, company_id, department_id')
      .eq('is_active', true)
      .order('name');

    const { data, error } = await query;

    return { data, error };
  } catch (error) {
    console.error('Error fetching profiles:', error);
    return { data: null, error };
  }
};

/**
 * 取得同公司所有使用者
 * @param {number|null} companyId - 公司 ID
 */
export const getCompanyProfiles = async (companyId) => {
  try {
    if (!companyId) {
      return { data: [], error: null };
    }

    const { data, error } = await supabase
      .from('profiles')
      .select('id, email, name, avatar_url, role, company_id, department_id')
      .eq('company_id', companyId)
      .eq('is_active', true)
      .order('name');

    return { data: data || [], error };
  } catch (error) {
    console.error('Error fetching company profiles:', error);
    return { data: null, error };
  }
};

/**
 * 取得單一使用者資料
 */
export const getProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('id, email, name, avatar_url, role, company_id, department_id')
      .eq('id', userId)
      .single();

    return { data, error };
  } catch (error) {
    console.error('Error fetching profile:', error);
    return { data: null, error };
  }
};

/**
 * 取得單一使用者的 project_profiles（含 settings）
 */
export const getProjectProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('project_profiles')
      .select('user_id, settings')
      .eq('user_id', userId)
      .maybeSingle();

    return { data, error };
  } catch (error) {
    console.error('Error fetching project profile:', error);
    return { data: null, error };
  }
};

/**
 * 更新使用者設定（project_profiles.settings JSONB 欄位）
 */
export const updateUserSettings = async (userId, settings) => {
  try {
    const { data, error } = await supabase
      .from('project_profiles')
      .update({ settings })
      .eq('user_id', userId)
      .select()
      .single();

    return { data, error };
  } catch (error) {
    console.error('Error updating user settings:', error);
    return { data: null, error };
  }
};
